<template>
  <div>
    <v-chip
      :value="translatedSelectedText"
      :color="chipColor"
      :text-color="chipTextColor"
      @click="handleClickFilter"
    >
      <v-icon>
        ui-icon-filter
      </v-icon>
      <div class="mx-2">
        {{ translatedSelectedText }}
      </div>
      <v-icon
        size="16"
        @click="handleClickCloseFilter"
      >
        {{ closeIcon }}
      </v-icon>
    </v-chip>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import I18NextVue from 'i18next'

const { t, language } = I18NextVue
const options = { ns: language }

type Emits = {
  (e: 'click:show'): void // eslint-disable-line
  (e: 'click:close', event: Event): void // eslint-disable-line
}

const emit = defineEmits<Emits>()

const props = withDefaults(defineProps<{
  selected: string
  isActiveFilter: boolean
}>(), {
  selected: 'По оценке',
  isActiveFilter: false,
})

const translatedSelectedText = t(props.selected, options)

const closeIcon = computed(() => (props.isActiveFilter ? 'ui-icon-close-circle' : 'ui-icon-arrow-down'))
const chipColor = computed(() => (props.isActiveFilter ? 'primary' : 'bg-primary'))
const chipTextColor = computed(() => (props.isActiveFilter ? 'bg-gray-0' : 'primary'))

function handleClickFilter() {
  emit('click:show')
}

function handleClickCloseFilter(event: Event) {
  emit('click:close', event)
}
</script>
